import React, { useEffect, useRef, useState } from 'react';
import { Button, Checkbox, FormControlLabel, Popover, Stack, TextField } from '@mui/material';
import './Governance.scss';
import { dashboardUrl } from '../../../service/config';
import AnalyticsVisualization from '../../framework/analyticsVisualization';
import GovernanceJobs from './GovernanceJobs';
import StaleUser from './StaleUsers';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useSearchParams } from 'react-router-dom';
import { ReactComponent as DatePickerIcon } from '../../../assets/calendar-outline_white.svg';
import useStyles from '../../jobs/jobs_styles';
import MenuItem from '@mui/material/MenuItem';
import { ReactComponent as FilterIcon } from '../../../assets/ml_summary_filter.svg';
import { getDatabricksGovernanceChart, getDecodedToken, getDatabricksSectors } from '../../../service/service';

const Governance = () => {
	const [searchParameters, setSearchParameters] = useSearchParams();
	const dateFrom: string = searchParameters.get('fromDate')?.substring(0, 10) as string;
	const dateTo: string = searchParameters.get('toDate')?.substring(0, 10) as string;
	const startDt = moment(dateFrom).startOf('day').subtract(1, 'hours').format('YYYY-MM-DD');
	const endDt = moment(dateTo).endOf('day').subtract(1, 'hours').format('YYYY-MM-DD');
	const [fromDateTime, setFromDateTime] = useState<any>(
		searchParameters.has('fromDate') ? startDt : moment().startOf('day').subtract(1, 'hours')
	);
	const [propsFromDateTime, setPropsFromDateTime] = useState<any>(
		searchParameters.has('fromDate') ? startDt : null
	);
	const [propsToDateTime, setPropsToDateTime] = useState<any>(
		searchParameters.has('toDate') ? endDt : null
	);
	const [dateSelect, setDateSelect] = useState(0);

	// sector filter
	const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
	const [filterMenu, setFilterMenu] = useState<{
		xMouse: number;
		yMouse: number;
	} | null>(null);
	const classes = useStyles();
	const [itemsChecked, setItemsChecked] = useState(false);
	const [sectorOptionsList, setSectorOptionsList] = useState<any[]>([]);
	const [checkedList, setCheckedList] = useState<any[]>([]);
	const [currSectorFilter, setCurrSectorFilter] = useState<any[]>([]);
	const [sector, setSector] = useState<any[]>([]);
	const dataFetchedRef = useRef(false);


	const handleDateTimeChange = (field: any, dateTime: any) => {
		if (field === 'fromDateTime') setFromDateTime(dateTime);
		// else setFromDateTime(dateTime);
		localStorage.setItem('processedDate', moment(dateTime).format('YYYY-MM-DD'));
		applyDateTimeRange(dateTime);
		setDateSelect(dateSelect + 1);
	};

	const resetSearchParams = () => {
		if (searchParameters.has('fromDate') || searchParameters.has('toDate')) {
			searchParameters.delete('status');
			searchParameters.delete('scheduleDate');
			searchParameters.delete('fromDate');
			searchParameters.delete('toDate');
			setSearchParameters(searchParameters);
		}
	};
	const applyDateTimeRange = (dateTime: any) => {
		setPropsFromDateTime(dateTime);
		setPropsToDateTime(dateTime);
		resetSearchParams();
	};

	const filterClick = (event: any) => {
		event.preventDefault();
		setFilterMenu(
			filterMenu === null
				? {
					xMouse: Number.parseInt(event.clientX) - 20,
					yMouse: Number.parseInt(event.clientY) - 6
				}
				: null
		);
	};

	const handleClose = (event: any) => {
		setFilterMenu(null);
	};

	const selectAllCheck = (e: any) => {
		const { checked } = e.target;
		const collection: any[] = [];
		if (checked) setCheckedList(sectorOptionsList);
		else setCheckedList([]);
		setItemsChecked(checked);
	};

	const handleChange = (e: any) => {
		const { value, checked } = e.target;
		const newlyChecked = [];
		if (checked && e.target.value) {
			newlyChecked.push(e.target.value);
		}
		if (checked) {
			setCheckedList([...checkedList, ...newlyChecked]);
			if(sectorOptionsList.length === (checkedList.length + newlyChecked.length)){
				setItemsChecked(true);
			}
		} else {
			setCheckedList(checkedList.filter((item) => item !== value));
			setItemsChecked(false);
		}
	};
	const handleOkClick = (event: any) => {
		if (checkedList.length > 0) {
			setCurrSectorFilter(checkedList);
		} else {
			setCurrSectorFilter([]);
		}
		
		if (sectorOptionsList.length == checkedList.length) {
			setCheckedList([])
			localStorage.setItem('d-resource-sector-filter', JSON.stringify([]));
		} else {
			localStorage.setItem('d-resource-sector-filter', JSON.stringify(checkedList));
		}
		setSector(checkedList);
		handleClose(event);
	};

	async function fetchSectorOptionsData() {
		const sectorRes = await getDatabricksSectors('1', '100', '');
		if (sectorRes.success) {
			setSectorOptionsList(sectorRes.data.sector.map((x: any) => {
				if (x.name === 'S&T') {
					return 'SNT';
				} else if (x.name === 'Europe') {
					return 'EUROPE';
				}
				else if (x.name === 'Global') {
					return 'GLOBAL';
				}
				else {
					return x.name;
				}
			}));
		}
	}
	async function fetchDate() {
		const res = await getDatabricksGovernanceChart();
		if (res.success) {
			if (localStorage.getItem('processedDate')) {
				setFromDateTime(moment(localStorage.getItem('processedDate')));
				setPropsFromDateTime(moment(localStorage.getItem('processedDate')));
			} else {
				localStorage.setItem('processedDate',res.data.processedDate);
				setFromDateTime(moment(res.data.processedDate));
				setPropsFromDateTime(moment(res.data.processedDate));
			}
		}
	}
	useEffect(() => {
		fetchDate();
		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;
		if (userSector === 'all') fetchSectorOptionsData();
		let storedSectorFilter = localStorage.getItem('d-resource-sector-filter')
			? JSON.parse(localStorage.getItem('d-resource-sector-filter') ?? '')
			: null;
		if (storedSectorFilter) {
			setCheckedList(storedSectorFilter);
			setCurrSectorFilter(storedSectorFilter);
		}
		const activeId = document.getElementById('root');
		if (globalThis.location.pathname === '/databricks/governance/dashboard') {
			if (activeId) {
				activeId.classList.add('jobs-list-table');
				activeId.classList.remove('jobs-list','root');
				document.body.classList.add('jobs-exe-datas');
				document.body.classList.remove('jobs-run-table');
				document.body.classList.add('jobs-list-datas','databricks-jobs','datefilter-align-sector');
			}
		} else if (activeId) {
			activeId.classList.add('root');
			activeId.classList.remove('jobs-list-table', 'jobs-list');
			document.body.classList.remove('jobs-list-datas', 'jobs-run-table', 'jobs-exe-datas');
		}
	}, [])
	let fromDate = moment(propsFromDateTime).format('YYYY-MM-DD');
	let toDate = moment(propsToDateTime).format('YYYY-MM-DD');
	let otherParams: any = {
		'var-sector': currSectorFilter
	}
	if (propsFromDateTime) {
		otherParams = {
			'var-fromDate': fromDate || '',
			'var-toDate': toDate || '',
			'var-sector': currSectorFilter
		}
	}
	return (


		<div className="dashboard-panel job-schedules-wrap">
			<div className="job-exexutions-dateFilter-div">
				{/* [Date Range Menu] */}
				<div style={{ display: 'flex', alignItems: 'center', padding: '-12px', marginTop: '-22px' }}>
					{/* condition for default Today  */}
					{
						<LocalizationProvider className="outerDateContainer" dateAdapter={AdapterMoment}>
							<DatePicker
								showToolbar={true}
								components={{
									OpenPickerIcon: DatePickerIcon
								}}
								 maxDate={new Date()} 
								PopperProps={{ placement: 'auto' }}
								className="dateFilterID"
								value={moment(fromDateTime).tz('America/New_York')}
								onChange={(dateTime) => {
									handleDateTimeChange('fromDateTime', dateTime);
								}}
								renderInput={(params: any) => <TextField name="startDateTime" {...params} />}
							/>
						</LocalizationProvider>
					}
				</div>

				{/* Code for sector filter */}
				<Stack>
					{userSector === 'all' ? (
						<FilterIcon onClick={filterClick} className="sector-filter1" />
					) : (
						<div className="separeat_sector">Sector: {getDecodedToken()?.sector?.name}</div>
					)}
					<Popover
						open={filterMenu !== null}
						onClose={handleClose}
						className="filterContainer"
						anchorReference="anchorPosition"
						anchorPosition={filterMenu === null ? undefined:{ top: filterMenu.yMouse, left: filterMenu.xMouse } }
					>
						<div className="text-filter-row">
							<div className="selectAll-sec">
								<MenuItem className="selectAll">
									<FormControlLabel
										className={classes.checkbox}
										label="All"
										control={
											<Checkbox
												color="success"
												value="all"
												checked={itemsChecked}
												onChange={(e) => {
													selectAllCheck(e);
												}}
											/>
										}
									/>
								</MenuItem>
								<div className="checkbox-sec">
									{sectorOptionsList?.map((filter: any) => {
										let labelValue = filter;
										if (filter === true) {
											labelValue = 'Yes';
										} else if (filter === false) {
											labelValue = 'No';
										}
										return (
											<MenuItem key={filter}>
												<FormControlLabel
													className={classes.checkbox}
													label={labelValue}
													control={
														<Checkbox
															color="success"
															value={filter}
															checked={
																(filter === true && checkedList.includes('true')) ||
																(filter === false && checkedList.includes('false')) ||
																checkedList.includes(filter)
															}
															onChange={(e) => {
																handleChange(e);
															}}
														/>
													}
												/>
											</MenuItem>
										);
									})}
								</div>
							</div>
							<div className="buttonSec">
								<Button variant="contained" className={classes.cancelBtn} onClick={handleClose}>
									cancel
								</Button>
								<Button variant="contained" className={classes.okBtn} onClick={handleOkClick}>
									ok
								</Button>
							</div>
						</div>
					</Popover>
				</Stack>
			</div>
				<Stack>
					<AnalyticsVisualization
						params={{
							dashboardUrl: dashboardUrl.databricksgovernance,
							className: 'dataBricksGovernanceIframeContainer',
							otherParams: otherParams,
							seamless: true
						}}
					/>
				</Stack>
			<GovernanceJobs fromDateTime={propsFromDateTime} toDateTime={propsFromDateTime} sectorFilter={sector} setFromDateTime={setFromDateTime}
				dateSelect={dateSelect} />
			<StaleUser fromDateTime={propsFromDateTime} toDateTime={propsFromDateTime} sectorFilter={sector} setFromDateTime={setFromDateTime}
				dateSelect={dateSelect} />
		</div>
	);
};

export default Governance;
